import { moduleImportsNames } from "./moduleImportsNames";

export default {
  [moduleImportsNames.SET_IMPORTS_TIP](
    state: any,
    payload: { id: string; close: boolean }
  ) {
    state.tips[payload.id] = payload.close;
    localStorage.setItem("tipsImports", JSON.stringify(state.tips));
  },
};
